var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.to)?_c('router-link',{staticClass:"w-toolbar-text",attrs:{"to":_vm.computedTo},nativeOn:{"click":function($event){return _vm.click()}}},[_c('div',[_vm._t("default")],2)]):_c('div',{staticClass:"w-toolbar-text"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }